<template>
  <div class="about">
    <banner />
    <div class="section disclose-info">
      <div class="column">
        <h2>信息公开</h2>
      </div>
      <el-row :gutter="20">
        <el-col
          :span="isPc ? 12 : 24"
          v-for="item in InfoList"
          :key="item.comRelatedId"
        >
          <div
            class="info-item justify-between items-center little_hand"
            @click="toCaseDetails(item.comRelatedId)"
          >
            <div class="info-left">
              <h4 class="items-end">{{ item.title }}</h4>
              <time>{{ $dayjs(item.createTime).format("YYYY-MM-DD") }}</time>
            </div>
            <svg-icon icon-class="direction"></svg-icon>
          </div>
        </el-col>
      </el-row>
      <div class="justify-center" style="margin-top:40px">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          :page-size="pageSize"
          :total="total"
          @current-change="changeSize"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "../common/banner.vue";
import { getRelatedByInfo } from "@/assets/api/about.js";
import { mapState } from "vuex";

export default {
  name: "about",
  components: {
    banner,
  },
  data() {
    return {
      InfoList: [],
      total: 0,
      pageNum: 1,
      pageSize: 8,
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      getRelatedByInfo({
        orderByColumn: "orderNum",
        isAsc: "desc",
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        this.total = res.data.data.total;

        // console.log(res.data);
        this.InfoList = res.data.data.rows;
      });
    },
    changeSize(e) {
      console.log(e);
      this.pageNum = e;
      this.init();
    },
    toCaseDetails(comRelatedId) {
      this.$router.push({
        path: `/case-details/${comRelatedId}`,
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.section {
  width: 1000px;
  margin: auto;
  position: relative;
}
.column {
  padding-top: 60px;
  margin-bottom: 24px;

  h2 {
    font-size: 32px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #2c2c2e;
    line-height: 42px;
  }
}
.disclose-info {
  padding-bottom: 80px;
  .info-item {
    background: #f8f8fa;
    padding: 20px;
    margin-bottom: 20px;
    transition: all 0.3s;
    h4 {
      font-size: 16px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #2c2c2e;
      line-height: 21px;
    }
    time {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #aeaeb2;
      line-height: 19px;
      margin-top: 8px;
    }
    .svg-icon {
      width: 48px;
      height: 24px;
      color: #f8f8fa;
    }
  }
  .info-item:hover {
    background: #005bac;
    h4 {
      color: #ffffff;
    }
    time {
      color: rgba($color: #ffffff, $alpha: 0.8);
    }
    .svg-icon {
      color: #ffffff;
    }
  }
}
@media screen and (max-width: 768px) {
  .section {
    width: 100%;
    padding: 0 20px;
  }
  .column {
    padding-top: 60px;
    margin-bottom: 16px;

    h2 {
      font-size: 24px;
      line-height: 31px;
    }
  }
  .disclose-info {
    padding-bottom: 60px;
    .info-item {
      margin-bottom: 16px;
    }
  }
}
</style>
<style>
.el-pager li {
  font-size: 16px;
  padding: 0 8px;
  height: auto;
}
.el-pager li:hover {
  color: #005bac;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #005bac;
}
</style>


// WEBPACK FOOTER //
// src/views/disclose-info/index.vue